<template>
  <div>
    <div class="title">
      <div class="iconfont iconfanhui" @click="$router.go(-1)"></div>
      <div class="text">库存</div>
      <div>
        <span style="padding-right:13px" class="iconfont iconkucun"></span><span class="iconfont iconkucun"></span>
      </div>
    </div>

    <div class="head">
      
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{

    }
  }
}
</script>
<style lang="scss" scoped>
  .title{
    display: flex;
    justify-content: space-between;
    line-height: 44px;
    padding: 0 14px;
    height: 44px;
    background: #fff;
    font-size: 15px;
    .iconfont{
      font-size: 25px;
    }
  }
</style>
<style>
  body{
    background:rgba(237,237,237,1);
  }
</style>



